import React from 'react';
import { useTranslation } from 'react-i18next';
import Alert from '@justgiving/alert';
import Modal from '@justgiving/modal';
import Loading from '@justgiving/loading';
import config from '../../config';
import TeamLockTypes from '../../consts/lockTypes';

type Props = {
  teamLockType: TeamLockTypes;
  updateTeamLocks: (teamLockType: TeamLockTypes) => Promise<void>;
  onCloseModal: () => void;
  isModalOpen: boolean;
  isInFlight?: boolean;
  isError: boolean;
};

const UpdateTeamLocksModal = ({
  teamLockType,
  onCloseModal,
  isModalOpen,
  isInFlight,
  isError,
  updateTeamLocks,
}: Props) => {
  const handleClick = async () => {
    await updateTeamLocks(teamLockType).catch(() => {});
    onCloseModal();
  };

  const { t } = useTranslation();

  return (
    <Modal
      classNames="jg-space-phmd@lg jg-tc-update-team-modal-container"
      isOpen={isModalOpen}
      onRequestClose={onCloseModal}
    >
      <div className="jg-text--center">
        <img
          className="jg-space-mvmd"
          src={`${config.publicPath}public/robot-are-you-sure.svg`}
          alt="JustGiving robot"
          width="130"
          height="123"
        />
        <h1 className="jg-space-mbms container--heading">
          {t('content.updateTeamLocksModal.heading')}
        </h1>
        <p className="jg-text--large">
          {t(`content.updateTeamLocksModal.paragraphOne.${teamLockType}`)}
        </p>
        <p className="jg-text--large jg-space-mtms jg-space-mbmd jg-space-mbxl@lg">
          {t('content.updateTeamLocksModal.paragraphTwo')}
        </p>
      </div>
      <div className="jg-tc-button-container">
        <button
          type="button"
          data-qa="unlock-team"
          disabled={isInFlight}
          onClick={handleClick}
          className="jg-btn jg-space-mbms"
        >
          {isInFlight ? (
            <Loading size="small" colour="purple" />
          ) : (
            t(`content.updateTeamLocksModal.yes.${teamLockType}`)
          )}
        </button>

        <button
          type="button"
          onClick={onCloseModal}
          className="jg-btn jg-btn--ghost"
        >
          {t('global.button.cancel')}
        </button>
        {isError && (
          <Alert type="warning" displayType="inline" className="jg-space-mvmd">
            {t('global.error.fatal')}
          </Alert>
        )}
      </div>
    </Modal>
  );
};

export default UpdateTeamLocksModal;
